import { useEffect, useMemo, useState } from "react";
import { circlePinFactory } from "./CirclePinFactory";
import { tearDropPinFactory } from "./TearDropPinFactory";
import { mergeSvg } from "../MergeSvg";
import { logInfo } from "@lib/logger";

const usePin = (
  pinType: "circle" | "tearDrop",
  iconUrl: string,
  color: string,
) => {
  const [icon, setIcon] = useState<string | null>(null);
  const [pinWithIcon, setPinWithIcon] = useState<string>("");

  useEffect(() => {
    (async () => {
      const response = await fetch(iconUrl);
      if (!response.ok) {
        logInfo("Failed to fetch icon", response);
        return;
      }
      const svg = await response.text();
      setIcon(svg);
    })();
  }, [iconUrl]);

  const pin = useMemo(() => {
    return pinType === "circle"
      ? circlePinFactory.createPin(color)
      : tearDropPinFactory.createPin(color);
  }, [pinType, color]);

  useEffect(() => {
    if (icon) {
      try {
        const mergedSvg = mergeSvg(
          pin.svg,
          icon,
          pin.iconOffsetX,
          pin.iconOffsetY,
        );
        if (mergedSvg) {
          setPinWithIcon(mergedSvg);
        }
      } catch (error) {
        logInfo("Error merging SVGs", error);
      }
    }
  }, [icon, pin.iconOffsetX, pin.iconOffsetY, pin.svg]);

  return {
    pin: pinWithIcon,
    width: pin.width,
    height: pin.height,
    anchorX: pin.anchorX,
    anchorY: pin.anchorY,
  };
};

export { usePin };
